<div
  class="clearwater-details"
  *ngIf="rowCwTransactionData.length > 0; else noCwTransactionData"
>
  <nf-table-layout
    [isSectionTitle]="true"
    [gridOptions]="cwTransactionGridOptions"
    [data]="rowCwTransactionData"
    [autoResizeGrid]="false"
    hideClearAll
    hideTitle
  >
  </nf-table-layout>
</div>
<div>
  <ng-template #noCwTransactionData>
    <hs-panel-card header="No data available"></hs-panel-card>
  </ng-template>
</div>
